import { QuantityBreakDTO } from '@/api/dto/QuantityBreakDTO';
import { QuantityBreak } from '@/models/entities/QuantityBreak';
import { CrudModule, IModuleState } from './CrudModule';
import { EntityType } from '@/store/entityModules/types';
import { SearchQueryFilters } from '@/models/filters/SearchQueryFilters';
import { GetterTree } from 'vuex';

class QuantityBreakModule extends CrudModule<QuantityBreak, QuantityBreakDTO> {
  state: IModuleState<QuantityBreak, QuantityBreakDTO> = {
    ...this.state,

    entityType: EntityType.QUANTITY_BREAK,
    queryFilters: new SearchQueryFilters({}),
  };

  getters: GetterTree<IModuleState<QuantityBreak, QuantityBreakDTO>, any> = {
    ...this.getters,

    getItem: state => (id: number) => {
      const item = state.items.find((i: QuantityBreak) => i.id === id);
      return item || null;
    },
  };
}

const quantityBreaksModule = new QuantityBreakModule();
export default quantityBreaksModule;
